import React from 'react';
import { Box, StatusBadge } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from '../Accessories.styles';
const AccessoryIncludedBadge = themeStyles.apply(Box, 'AccessoryIncludedBadge');
const AccessoryBadgeAlert = ({ hasSideSpacing, hasTopSpacing }) => {
    const { t } = useTranslation();
    return (React.createElement(AccessoryIncludedBadge, { hasSideSpacing: hasSideSpacing, hasTopSpacing: hasTopSpacing },
        React.createElement(StatusBadge, { statusIconName: "selected", statusText: t('Pages.Bap.includedLabel') })));
};
export default AccessoryBadgeAlert;
